import { HttpBackend, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NEVER, Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AbstractConfigurationProvider } from '../abstract-configuration-provider/abstract-configuration-provider.service';
import { AbstractTokenProvider } from '../abstract-token-provider/abstract-token-provider.service';

@Injectable()
export class AuthenticationHttpHandlerService implements HttpHandler {
  constructor(
    private httpBackend: HttpBackend,
    private tokenProvider: AbstractTokenProvider,
    private configurationProvider: AbstractConfigurationProvider,
  ) {}

  handle(req: HttpRequest<unknown>): Observable<HttpEvent<unknown>> {
    return this.getToken().pipe(
      map((jwtToken) => this.getRequestWithAuthorizeHeader(jwtToken, req)),
      switchMap((newReq) => this.httpBackend.handle(newReq)),
    );
  }

  private getRequestWithAuthorizeHeader(token: string, originalReq: HttpRequest<unknown>): HttpRequest<unknown> {
    return originalReq.clone({
      url: `${this.configurationProvider.getConfiguration().baseUrl}/${originalReq.url}`,
      headers: originalReq.headers.append('Authorization', `Bearer ${token}`),
    });
  }

  private getToken(): Observable<string> {
    return this.tokenProvider.getJwtToken().pipe(
      switchMap((token) => {
        if (typeof token === 'string') {
          return of(token);
        } else {
          return NEVER;
        }
      }),
      take(1),
    );
  }
}
